import React, { useRef, useImperativeHandle } from "react";
import { Grid } from "@mui/material";
import { TextField, Button, Box } from "@curves/ui-base";
import { SignBox } from "@icoach/components";
import useMessageDialog from "@util/hook/useMessageDialog";
import { getErrorModuleStatus, refIsRequiredError } from "@util/utils";
import useBankAccountState from "@icoach/components/bankAccount/useBankAccountState";

const BankAccount = React.forwardRef((props, ref) => {
	const {
		className,
		defaultValue = {},
		baseProfile = {},
		errorModule = {},
		readOnly: readOnlyProp = false,
		showSignature = false,
		showApplyBaseProfileButton = false,
	} = props;
	const setMessageDialog = useMessageDialog();
	const { bankAccountInfo, onUpdateField } = useBankAccountState(defaultValue);

	const handleChange = (fieldName) => (e) => {
		const value = e.target.value;
		onUpdateField(fieldName, value);
	};

	const signImgRef = useRef(null);
	const fieldRefs = useRef({});

	const handleApplyBaseProfile = () => {
		const { identifierID, memberName } = baseProfile || {};

		if (!identifierID) {
			setMessageDialog({
				open: true, title: "提醒", msg: "很抱歉！無法取得相關資料，謝謝。"
			});
		} else {
			onUpdateField('bankAccountID', identifierID);
			onUpdateField('bankAccountName', memberName);
		}
	};

	useImperativeHandle(ref, () => ({
			getResult: () => {
				let result = {
					...bankAccountInfo
				};

				if (signImgRef.current && signImgRef.current.getResult) {
					result.signImg = signImgRef.current.getResult();
				}

				return result;
			},
			isError: () => refIsRequiredError(fieldRefs.current)
		}), // eslint-disable-next-line
		[bankAccountInfo]);


	return (
		<Box className={className}>
			<Grid container spacing={3}>
				<Grid item xs={6}>
					<TextField
						label={"銀行代碼"}
						ref={ref => fieldRefs.current["bankCode"] = ref}
						value={bankAccountInfo?.bankCode || ""}
						{...getErrorModuleStatus(errorModule, "bankCode")}
						onChange={handleChange("bankCode")}
						readOnly={readOnlyProp}
						fullWidth
						required
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label={"銀行名稱"}
						ref={ref => fieldRefs.current["bankName"] = ref}
						value={bankAccountInfo?.bankName || ""}
						{...getErrorModuleStatus(errorModule, "bankName")}
						onChange={handleChange("bankName")}
						readOnly={readOnlyProp}
						fullWidth
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label={"銀行帳號"}
						ref={ref => fieldRefs.current["bankAccountID"] = ref}
						value={bankAccountInfo?.bankAccount || ""}
						{...getErrorModuleStatus(errorModule, "bankAccount")}
						onChange={handleChange("bankAccount")}
						readOnly={readOnlyProp}
						fullWidth
						required
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label={"銀行帳戶"}
						ref={ref => fieldRefs.current["bankAccountName"] = ref}
						value={bankAccountInfo?.bankAccountName || ""}
						{...getErrorModuleStatus(errorModule, "bankAccountName")}
						onChange={handleChange("bankAccountName")}
						readOnly={readOnlyProp}
						fullWidth
					/>
				</Grid>
				<Grid item xs={6}>
					<TextField
						label={"帳戶身分證字號"}
						ref={ref => fieldRefs.current["bankAccountID"] = ref}
						value={bankAccountInfo?.bankAccountID || ""}
						{...getErrorModuleStatus(errorModule, "bankAccountID")}
						onChange={handleChange("bankAccountID")}
						readOnly={readOnlyProp}
						fullWidth
						required
					/>
				</Grid>
				<Grid item xs={6}>
					{!readOnlyProp && showApplyBaseProfileButton && (
						<Button variant="contained" color="secondary" className="mt-4" onClick={handleApplyBaseProfile}>
							同基本資料
						</Button>)}
				</Grid>
				{!readOnlyProp && showSignature && (<Grid item xs={6}>
					<SignBox
						title={"帳戶持有人簽名"}
						ref={signImgRef}
						defaultValue={defaultValue.signImg}
						{...getErrorModuleStatus(errorModule, "signImg")}
						readOnly={readOnlyProp}
						required
					/>
				</Grid>)}
			</Grid>
		</Box>
	);
});

export default BankAccount;
